import type { SVGProps } from 'react'
const LineComponentCard = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M17.25 2H6.75A2.755 2.755 0 0 0 4 4.75v14.5A2.755 2.755 0 0 0 6.75 22h10.5A2.755 2.755 0 0 0 20 19.25V4.75A2.755 2.755 0 0 0 17.25 2m1.25 17.25c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25V12h13zm0-8.75h-13V4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25zm-2 3.5h-9v1.5h9zm-9 3h6v1.5h-6z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineComponentCard }
